"use strict";
/*
 * IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: IBM Cognos Analytics
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const react_1 = tslib_1.__importDefault(require("react"));
const carbon_components_react_1 = require("carbon-components-react");
const StringResource_1 = require("../nls/StringResource");
const utils_1 = require("../utils");
const COMPONENT_NAME = 'InlineLoading';
const DISPLAY_NAME = (0, utils_1.getDisplayName)(COMPONENT_NAME);
const DEFAULT_TID = (0, utils_1.getDefaultTid)(COMPONENT_NAME);
const activeIconDesc = StringResource_1.stringResource.get('inlineLoadingActiveIconDesc');
const errorIconDesc = StringResource_1.stringResource.get('inlineLoadingErrorIconDesc');
const finishedIconDesc = StringResource_1.stringResource.get('inlineLoadingFinishedIconDesc');
const inactiveIconDesc = StringResource_1.stringResource.get('inlineLoadingInactiveIconDesc');
const iconDescriptionLookup = {
    active: activeIconDesc,
    error: errorIconDesc,
    finished: finishedIconDesc,
    inactive: inactiveIconDesc,
};
const InlineLoading = react_1.default.forwardRef((props, ref) => {
    const { 
    // remove - remapped and local props
    'data-tid': dataTid, iconDescription } = props, 
    // pass all other props to Carbon
    otherCarbonProps = tslib_1.__rest(props, ['data-tid', "iconDescription"]);
    const { status } = otherCarbonProps;
    const mappedProps = {
        'data-tid': dataTid !== null && dataTid !== void 0 ? dataTid : DEFAULT_TID,
        iconDescription: iconDescription !== null && iconDescription !== void 0 ? iconDescription : iconDescriptionLookup[status],
    };
    if (ref) {
        mappedProps.ref = ref;
    }
    return react_1.default.createElement(carbon_components_react_1.InlineLoading, Object.assign({}, otherCarbonProps, mappedProps));
});
InlineLoading.propTypes = {
    'data-tid': prop_types_1.default.string,
    iconDescription: prop_types_1.default.string,
};
InlineLoading.displayName = DISPLAY_NAME;
exports.default = InlineLoading;
